import { z } from "zod";

export const ClientConfigDto = z.object({
  minStudioVersion: z.number(),
  maintenanceEndsAt: z.string().nullable(),
});

export type ClientConfigDto = z.infer<typeof ClientConfigDto>;
